import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Busca from "@/pages/Busca";
import PerfilProfissional from "@/pages/PerfilProfissional";
import Beneficios from "@/pages/Beneficios";
import { BlogList, BlogPost } from "@/pages/Blog";
import { SejaAssociado, SejaParceiro } from "@/pages/Landings";
import { Login, Cadastro } from "@/pages/AuthPages";
import { Termos, Privacidade } from "@/pages/Legal";
import { AssocHome, AssocBuscar, AssocBeneficios, AssocCarteira, AssocPedidos, AssocPerfil } from "@/pages/AssociadoArea";
import PedidoStatus from "@/pages/PedidoStatus";
import Noticias from "@/pages/Noticias";
import { ProfissionalPainel, ClinicaPainel, AdminPainel } from "@/pages/Dashboards";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right"/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/buscar" element={<Busca/>}/>
          <Route path="/profissionais/:id" element={<PerfilProfissional/>}/>
          <Route path="/beneficios" element={<Beneficios/>}/>
          <Route path="/blog" element={<BlogList/>}/>
          <Route path="/blog/:slug" element={<BlogPost/>}/>
          <Route path="/noticias" element={<Noticias/>}/>
          <Route path="/seja-associado" element={<SejaAssociado/>}/>
          <Route path="/seja-parceiro" element={<SejaParceiro/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/cadastro" element={<Cadastro/>}/>
          <Route path="/termos" element={<Termos/>}/>
          <Route path="/privacidade" element={<Privacidade/>}/>

          <Route path="/pedidos/:numero" element={<PedidoStatus/>}/>
          <Route path="/app/associado" element={<AssocHome/>}/>
          <Route path="/app/associado/buscar" element={<AssocBuscar/>}/>
          <Route path="/app/associado/beneficios" element={<AssocBeneficios/>}/>
          <Route path="/app/associado/carteira" element={<AssocCarteira/>}/>
          <Route path="/app/associado/pedidos" element={<AssocPedidos/>}/>
          <Route path="/app/associado/favoritos" element={<AssocPedidos/>}/>
          <Route path="/app/associado/perfil" element={<AssocPerfil/>}/>

          <Route path="/painel/profissional/*" element={<ProfissionalPainel/>}/>
          <Route path="/painel/clinica/*" element={<ClinicaPainel/>}/>
          <Route path="/admin/*" element={<AdminPainel/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
